'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMSDInformations = undefined;
var _defineProperty2 = require('babel-runtime/helpers/defineProperty');
var _defineProperty3 = _interopRequireDefault(_defineProperty2);
var _extends3 = require('babel-runtime/helpers/extends');
var _extends4 = _interopRequireDefault(_extends3);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getMSDInformations = exports.getMSDInformations = function getMSDInformations(msdJson) {
  var attributesDefinitions = R.pathOr([], ['data', 'metadataStructures', 0, 'metadataStructureComponents', 'reportStructures', 0, 'metadataAttributes'], msdJson);
  var indexedConcepts = R.pipe(R.pathOr([], ['data', 'conceptSchemes', 0, 'concepts']), R.indexBy(R.prop('id')))(msdJson);
  var parseAttributes = function parseAttributes(parent) {
    return R.reduce(function (acc, attribute) {
      var id = attribute.id;
      var name = R.path([id, 'name'], indexedConcepts);
      var hierarchicalId = parent === '#ROOT' ? id : parent + '.' + id;
      var format = R.path(['localRepresentation', 'textFormat', 'textType'], attribute);
      if (R.has('metadataAttributes', attribute)) {
        var collection = parseAttributes(hierarchicalId)(attribute.metadataAttributes);
        return (0, _extends4.default)({}, acc, collection, (0, _defineProperty3.default)({}, hierarchicalId, {
          format: format,
          parent: parent,
          id: id,
          name: name
        }));
      }
      return R.assoc(hierarchicalId, {
        format: format,
        parent: parent,
        id: id,
        name: name
      }, acc);
    }, {});
  };
  return {
    attributes: parseAttributes('#ROOT')(attributesDefinitions)
  };
};